module.exports = __webpack_public_path__ + "static/media/1O2A0801.f6e42885.jpg";